<template>
    <v-row no-gutters>
        <template v-if="accountingPeriod">
            <v-col cols="12" class="mt-2">
                <v-select
                    v-model="accountingItemImportId"
                    :items="accountingItemImports"
                    label="Fichier importé (FEC, ...)"
                    :item-title="getAccountingItemImportTitle"
                    item-value="id"
                    density="compact"
                />
            </v-col>

            <v-col
                cols="12"
                class="d-flex justify-center align-right mb-2 align-center"
                v-if="accountingItemImportId"
            >
                <v-switch
                    v-model="moveDocumentIfFileAsMiscelleanous"
                    label="Garder les justificatifs"
                    hide-details
                    class="mr-4 mt-0"
                />
                <v-btn
                    rounded
                    elevation="0"
                    @click="
                        deleteLoading = false;
                        deleteDialog = true;
                    "
                    :disabled="!toDeleteDocuments.length && !toDeleteBankTransactions.length"
                    size="small"
                >
                    Supprimer
                </v-btn>
            </v-col>

            <v-col cols="12" class="mx-5" v-if="accountingItemImportId">
                <v-tabs v-model="tab" grow density="compact" variant="centered">
                    <v-tab
                        value="bankTransaction"
                        data-cy="AccountingPeriodOpening-bankTransaction"
                    >
                        <v-badge
                            color="success"
                            :content="bankTransactions.length || '-'"
                            location="end"
                            inline
                        >
                            Transactions bancaires
                        </v-badge>
                    </v-tab>

                    <v-tab value="documents" data-cy="AccountingPeriodOpening-documents">
                        <v-badge
                            color="success"
                            :content="badgeDocumentNumber || '-'"
                            location="end"
                            inline
                        >
                            Documents
                        </v-badge>
                    </v-tab>
                </v-tabs>

                <v-window v-model="tab">
                    <v-window-item value="bankTransaction">
                        <!-- Content for Transactions bancaires -->
                    </v-window-item>

                    <v-window-item value="documents">
                        <!-- Content for Documents -->
                    </v-window-item>
                </v-window>

                <v-window v-model="tab">
                    <v-window-item value="bankTransaction" class="pa-5">
                        <v-card class="default_card_wm" width="100%">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <v-row class="mb-2" v-if="bankTransactions.length">
                                            <v-spacer />
                                            <v-col cols="6" class="d-flex justify-end">
                                                <v-btn
                                                    elevation="0"
                                                    rounded
                                                    @click="selectAllBankTransactions()"
                                                    v-if="
                                                        toDeleteBankTransactions &&
                                                        bankTransactions.length !==
                                                            toDeleteBankTransactions.length
                                                    "
                                                    size="small"
                                                >
                                                    Sélectionner toutes les lignes bancaires
                                                </v-btn>
                                                <v-btn
                                                    elevation="0"
                                                    rounded
                                                    @click="diselectAllBankTransactions()"
                                                    v-else
                                                    size="small"
                                                >
                                                    Désélectionner toutes les lignes bancaires
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-list>
                                            <v-virtual-scroll
                                                :items="bankTransactions"
                                                height="500"
                                                item-height="70"
                                            >
                                                <template v-slot="{ item }">
                                                    <v-list-item
                                                        :key="item.id"
                                                        class="oss-list-item"
                                                        :style="{
                                                            background:
                                                                bankTransactionSelected &&
                                                                bankTransactionSelected.id ===
                                                                    item.id
                                                                    ? 'rgba(109, 192, 189, 0.3)'
                                                                    : '',
                                                        }"
                                                    >
                                                        <v-row>
                                                            <v-col
                                                                cols="1"
                                                                class="d-flex align-center"
                                                                @click="
                                                                    selectedBankTransaction(item.id)
                                                                "
                                                            >
                                                                <v-icon
                                                                    :color="
                                                                        isToDeleteBankTransaction(
                                                                            item.id,
                                                                        )
                                                                            ? 'secondary'
                                                                            : ''
                                                                    "
                                                                >
                                                                    {{
                                                                        isToDeleteBankTransaction(
                                                                            item.id,
                                                                        )
                                                                            ? "$check_box"
                                                                            : "$check_box_outline_blank"
                                                                    }}
                                                                </v-icon>
                                                            </v-col>
                                                            <v-col
                                                                cols="11"
                                                                @click="
                                                                    bankTransactionSelected = item
                                                                "
                                                            >
                                                                <v-list-item-title
                                                                    :class="{
                                                                        'text-decoration-line-through text--secondary':
                                                                            isToDeleteBankTransaction(
                                                                                item.id,
                                                                            ),
                                                                    }"
                                                                >
                                                                    {{ item.wordingOriginal }}
                                                                </v-list-item-title>
                                                                <v-list-item-subtitle
                                                                    :class="{
                                                                        'text-decoration-line-through text--secondary d-flex justify-space-between':
                                                                            isToDeleteBankTransaction(
                                                                                item.id,
                                                                            ),
                                                                    }"
                                                                >
                                                                    <span>
                                                                        {{
                                                                            formatDate(
                                                                                item.dateDebit,
                                                                            )
                                                                        }}
                                                                    </span>
                                                                    <span>
                                                                        {{
                                                                            newCommonFormatCurrency(
                                                                                item.amount,
                                                                                undefined,
                                                                            )
                                                                        }}
                                                                    </span>
                                                                </v-list-item-subtitle>
                                                            </v-col>
                                                        </v-row>
                                                    </v-list-item>
                                                </template>
                                            </v-virtual-scroll>
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-window-item>

                    <v-window-item value="documents" class="pa-5">
                        <v-card class="default_card_wm" width="100%">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <v-row class="mb-2" v-if="documents.length">
                                            <v-spacer />
                                            <v-col cols="6" class="d-flex justify-end">
                                                <v-btn
                                                    elevation="0"
                                                    rounded
                                                    @click="selectAllDocuments()"
                                                    v-if="
                                                        documents.length !==
                                                        toDeleteDocuments.length
                                                    "
                                                    size="small"
                                                >
                                                    Sélectionner tous les documents
                                                </v-btn>
                                                <v-btn
                                                    elevation="0"
                                                    rounded
                                                    @click="diselectAllDocuments()"
                                                    v-else
                                                    size="small"
                                                >
                                                    Désélectionner tous les documents
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-list>
                                            <v-virtual-scroll
                                                :items="documents"
                                                height="500"
                                                item-height="70"
                                            >
                                                <template v-slot="{ item }">
                                                    <v-list-item
                                                        :key="item.id"
                                                        class="oss-list-item"
                                                        :style="{
                                                            background:
                                                                documentSelected &&
                                                                documentSelected.id === item.id
                                                                    ? 'rgba(109, 192, 189, 0.3)'
                                                                    : '',
                                                        }"
                                                    >
                                                        <v-row>
                                                            <v-col
                                                                cols="1"
                                                                class="d-flex align-center"
                                                                @click="selectedDocument(item.id)"
                                                            >
                                                                <v-icon
                                                                    :color="
                                                                        isToDeleteDocument(item.id)
                                                                            ? 'secondary'
                                                                            : ''
                                                                    "
                                                                >
                                                                    {{
                                                                        isToDeleteDocument(item.id)
                                                                            ? "$check_box"
                                                                            : "$check_box_outline_blank"
                                                                    }}
                                                                </v-icon>
                                                            </v-col>
                                                            <v-col
                                                                cols="11"
                                                                @click="documentSelected = item"
                                                            >
                                                                <v-list-item-title
                                                                    :class="{
                                                                        'text-decoration-line-through text--secondary':
                                                                            isToDeleteDocument(
                                                                                item.id,
                                                                            ),
                                                                    }"
                                                                >
                                                                    {{ getDocumentTitle(item) }}
                                                                </v-list-item-title>
                                                                <v-list-item-subtitle
                                                                    :class="{
                                                                        'text-decoration-line-through text--secondary d-flex justify-space-between':
                                                                            isToDeleteDocument(
                                                                                item.id,
                                                                            ),
                                                                    }"
                                                                >
                                                                    <span>
                                                                        {{ formatDate(item.date) }}
                                                                    </span>
                                                                    <span>
                                                                        {{
                                                                            newCommonFormatCurrency(
                                                                                item.grossAmountSigned,
                                                                                undefined,
                                                                            )
                                                                        }}
                                                                    </span>
                                                                </v-list-item-subtitle>
                                                            </v-col>
                                                        </v-row>
                                                    </v-list-item>
                                                </template>
                                            </v-virtual-scroll>
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-window-item>
                </v-window>
            </v-col>
            <v-col cols="12" class="d-flex justify-center" v-else>
                Aucune pièce n'a été detectée pour cette periode
            </v-col>
        </template>
        <template v-else>
            <v-col cols="12" class="d-flex justify-center"> Pas de période précédente </v-col>
        </template>

        <oss-dialog
            v-if="deleteDialog"
            v-model="deleteDialog"
            title="Suppression des éléments sélectionnés"
            @valid="valid"
            :validLoading="deleteLoading"
        >
            <h4 class="text-center" v-if="!stepData || !stepData.action">
                &#xca;tes-vous sûr(e) de vouloir supprimer les éléments sélectionnés ?
            </h4>
            <h4 class="text-center" v-if="stepData && !!stepData.action">Suppression en cours</h4>
            <v-progress-linear
                color="secondary"
                height="10"
                v-if="stepData && !!stepData.action"
                stream
                class="ml-2"
                :model-value="stepData.progressValue"
            />
        </oss-dialog>
    </v-row>
</template>

<script lang="ts">
import moment from "moment-timezone";
import gql from "graphql-tag";
import colors from "vuetify/lib/util/colors";
import { State2Way } from "@/decorators";

import { Apollo } from "@/decorators";
import { Document } from "../../../../types/types/indexTypes";
import DOCUMENT_IN_PERIOD from "../../graphql/document/FilterDocumentByPeriod.gql";
import BANK_TRANSACTIONS_IN_PERIOD from "../../graphql/bankTransaction/FilterBankTransactionsByPeriod.gql";
import DELETE_BANKTRANSACTIONS_AND_DOCUMENTS from "../../graphql/FecBankTransactionsAndDocumentsDeletation.gql";
import { getDocumentTitle } from "../../services/documentServices";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../../services/dateServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { NotificationBase } from "../NotificationBase";
import { Component, toNative } from "vue-facing-decorator";

@Component
export class CheckDoublonsWithAccountingItemImport extends NotificationBase {
    @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    accountingPeriod!: any;

    tab: string = "bankTransaction";

    replacedDocuments = [];
    replacedBankTransactions = [];

    toDeleteDocuments = [];
    toDeleteBankTransactions = [];

    documentSelected = null;
    bankTransactionSelected = null;

    accountingItemImportId = "";

    get accountingItemImport() {
        if (this.accountingItemImportId) {
            return this.accountingItemImports.find((aii) => aii.id === this.accountingItemImportId);
        }
        return null;
    }

    deleteLoading = false;
    deleteDialog = false;

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get badgeDocumentNumber() {
        return (
            this.documents.length - this.replacedDocuments.length - this.toDeleteDocuments.length
        );
    }

    get red() {
        return colors.red.accent1;
    }

    getDocumentTitle(document) {
        return getDocumentTitle(document, false);
    }

    beforeMount() {
        this.addListener("documentAndBankTransaction");
    }

    beforeDestroy() {
        this.removeListener();
    }

    onRunning() {
        this.deleteLoading = true;
    }

    onEnded() {
        this.deleteLoading = false;
        this.deleteDialog = false;
        this.resetNotificationStepData();
        this.refresh();
    }

    @Apollo({
        query: DOCUMENT_IN_PERIOD,
        variables() {
            debugger;
            return {
                companyId: this.companyId,
                beginDate: getDBFormattedStartDate(this.accountingItemImportStart),
                endDate: getDBFormattedEndDate(this.accountingItemImportEnd),
                accountingItemImportId: this.accountingItemImportId,
                orderBy: "date_ASC",
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return (
                !this.companyId ||
                !this.accountingItemImportStart ||
                !this.accountingItemImportEnd ||
                !this.accountingItemImportId
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.documents && data.documents.length) {
                    this.documents = data.documents.map((x) => ({
                        ...x,
                        isActive: false,
                    }));
                } else {
                    this.documents = [];
                }
                this.diselectAllDocuments();
            }
        },
    })
    documents: Document[] = [];

    @Apollo({
        query: gql`
            query (
                $companyId: ID!
                $accountingPeriodId: ID!
                $startDate: DateTime
                $endDate: DateTime
            ) {
                accountingItemImports(
                    where: {
                        company: { id: $companyId }
                        OR: [
                            { accountingPeriod: { id: $accountingPeriodId } }
                            { AND: { startDate_gte: $startDate, endDate_lte: $endDate } }
                        ]
                    }
                ) {
                    id
                    name
                    startDate
                    endDate
                    name
                    accountingPeriod {
                        id
                        start
                        end
                    }
                }
            }
        `,
        skip() {
            return !this.accountingPeriod || !this.accountingPeriod.id;
        },
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriod.id,
                startDate: this.accountingPeriod.start,
                endDate: this.accountingPeriod.end,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.accountingItemImportId = "";
            if (!loading && data && data.accountingItemImports) {
                this.accountingItemImports = data.accountingItemImports;
            } else {
                this.accountingItemImports = [];
            }
        },
        debounce: 500,
    })
    accountingItemImports = [];

    get accountingItemImportStart() {
        if (this.accountingItemImport) {
            if (this.accountingItemImport.accountingPeriod) {
                return this.accountingItemImport.accountingPeriod.start;
            }
            if (this.accountingItemImport.startDate) {
                return this.accountingItemImport.startDate;
            }
        }
        return "";
    }

    get accountingItemImportEnd() {
        if (this.accountingItemImport) {
            if (this.accountingItemImport.accountingPeriod) {
                return this.accountingItemImport.accountingPeriod.end;
            }
            if (this.accountingItemImport.startDate) {
                return this.accountingItemImport.endDate;
            }
        }
        return "";
    }

    @Apollo({
        query: BANK_TRANSACTIONS_IN_PERIOD,
        variables() {
            return {
                companyId: this.companyId,
                beginDate: getDBFormattedStartDate(this.accountingItemImportStart),
                endDate: getDBFormattedEndDate(this.accountingItemImportEnd),
                accountingItemImportId: this.accountingItemImportId,
                orderBy: "date_ASC",
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return (
                !this.companyId ||
                !this.accountingItemImportStart ||
                !this.accountingItemImportEnd ||
                !this.accountingItemImportId
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.bankTransactions && data.bankTransactions.length) {
                    this.bankTransactions = data.bankTransactions.map((x) => ({
                        ...x,
                        isActive: false,
                    }));
                } else {
                    this.bankTransactions = [];
                }
                this.diselectAllBankTransactions();
            }
        },
    })
    bankTransactions: any[] = [];

    formatDate = function (date) {
        return moment(date).format("DD MMMM YYYY");
    };

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    isToDeleteDocument = function whetherTheDocumentIsSelectedForDeletion(id) {
        return !!this.toDeleteDocuments.filter((x) => x === id).length;
    };

    isToDeleteBankTransaction = function whetherTheBankTransactionIsSelectedForDeletion(id) {
        return !!this.toDeleteBankTransactions.filter((x) => x === id).length;
    };

    selectedDocument = function addOrDeleteTheDocumentToTheListOfDocumentsToBeDeleted(id) {
        const sizeList = this.toDeleteDocuments.length;
        this.toDeleteDocuments = this.toDeleteDocuments.filter((x) => x !== id);
        if (this.toDeleteDocuments.length === sizeList) {
            this.replacedDocuments = this.replacedDocuments.filter(
                (x) => x.document.id !== this.documentSelected.id,
            );
            this.toDeleteDocuments.push(id);
        }
    };

    selectedBankTransaction = function addOrDeleteTheBankTransactionToTheListOfDocumentsToBeDeleted(
        id,
    ) {
        const sizeList = this.toDeleteBankTransactions.length;
        this.toDeleteBankTransactions = this.toDeleteBankTransactions.filter((x) => x !== id);
        if (this.toDeleteBankTransactions.length === sizeList) {
            this.replacedBankTransactions = this.replacedBankTransactions.filter(
                (x) => x.bankTransaction.id !== this.bankTransactionSelected.id,
            );
            this.toDeleteBankTransactions.push(id);
        }
    };

    selectAllDocuments = function addAllDocumentsInTheToDeletationList() {
        this.toDeleteDocuments = this.documents.map((x) => x.id);
    };

    selectAllBankTransactions = function addAllBankTransactionsInTheToDeletationList() {
        this.toDeleteBankTransactions = this.bankTransactions.map((x) => x.id);
    };

    diselectAllDocuments = function removeAllDocumentsInTheToDeletationList() {
        this.toDeleteDocuments = [];
    };

    diselectAllBankTransactions = function removeAllBankTransactionsInTheToDeletationList() {
        this.toDeleteBankTransactions = [];
    };

    linkWithDocument = function linkOrRemoveTheLinkBetweenTheAccountingItemAndTheDocument(
        accountingItem,
    ) {
        const sizeList = this.replacedDocuments.length;
        debugger;
        this.replacedDocuments = this.replacedDocuments.filter(
            (x) =>
                !(
                    x.document.id === this.documentSelected.id &&
                    x.accountingItem.id === accountingItem.id
                ),
        );
        if (this.replacedDocuments.length === sizeList) {
            this.toDeleteDocuments = this.toDeleteDocuments.filter(
                (x) => x !== this.documentSelected.id,
            );
            this.replacedDocuments = this.replacedDocuments.filter(
                (x) =>
                    !(
                        x.document.id !== this.documentSelected.id &&
                        x.accountingItem.id === accountingItem.id
                    ),
            );
            this.replacedDocuments.push({
                document: { ...this.documentSelected },
                accountingItem: { ...accountingItem },
            });
        }
    };

    isLinkedWithDocument = function knowIfTheAccountingItemIsLinkedToTheDocument(id) {
        const documentLink = this.replacedDocuments.filter(
            (x) => x.document.id === this.documentSelected.id,
        );
        return documentLink && documentLink.length && documentLink[0].accountingItem.id === id;
    };

    isALinkedDocument = function knowIfTheDocumentIsLinkedWithAnAccountingItem(id) {
        return this.replacedDocuments.filter((x) => x.document.id === id).length;
    };

    isALinkedAccountingItem = function knowIfTheAccountingItemIsLinkedWithAnAccountingItem(id) {
        return this.replacedDocuments.filter((x) => x.accountingItem.id === id).length;
    };

    moveDocumentIfFileAsMiscelleanous: boolean = false;
    deleteId: string = "";

    async valid() {
        this.deleteLoading = true;
        const result = await this.$apollo.mutate({
            mutation: DELETE_BANKTRANSACTIONS_AND_DOCUMENTS,
            variables: {
                companyId: this.companyId,
                accountingItemImportId: this.accountingItemImportId,
                bankTransactionIds: this.toDeleteBankTransactions,
                documentIds: this.toDeleteDocuments,
                moveDocumentIfFileAsMiscelleanous: this.moveDocumentIfFileAsMiscelleanous,
            },
        });
        if (result.data?.deleteBanktransactionsAndDocuments?.id) {
            // console.log(
            //     "result.data.deleteBanktransactionsAndDocuments.id",
            //     result.data.deleteBanktransactionsAndDocuments.id,
            // );
            this.setNotificationStepData(
                result.data.deleteBanktransactionsAndDocuments.id,
                this.onRunning,
                this.onEnded,
            );
            // this.notificationStepData = new NotificationStepData(this, result.data.deleteBanktransactionsAndDocuments.id)
        } else {
            debugger;
        }
        // await this.$apollo.mutate({
        //     mutation: DELETE_DOCUMENTS,
        //     variables: {
        //         companyId: this.companyId,
        //         accountingItemImportId: this.accountingItemImportId,

        //         lightDelete: false,
        //         moveDocumentIfFileAsMiscelleanous: this.moveDocumentIfFileAsMiscelleanous
        //     }
        // })
        // await this.$apollo.mutate({
        //     mutation: DELETE,
        //     variables: {
        //         companyId: this.companyId,
        //         accountingItemImportId: this.accountingItemImportId,
        //         documentIds: this.toDeleteDocuments,
        //         bankTransactionIds: this.toDeleteBankTransactions,
        //         moveDocumentIfFileAsMiscelleanous: this.moveDocumentIfFileAsMiscelleanous
        //     }
        // })
        // this.deleteLoading = false
        // this.deleteDialog = false
        // this.refresh()
    }

    refresh() {
        if (this.$apollo.queries.bankTransactions) {
            this.$apollo.queries.bankTransactions.refetch();
        }
        if (this.$apollo.queries.documents) {
            this.$apollo.queries.documents.refetch();
        }
    }

    // @Watch('toDeleteDocuments', { deep: true })
    // test() {
    //     debugger
    // }

    getAccountingItemImportTitle(accountingItemImport) {
        // debugger
        const title = accountingItemImport.name;
        if (accountingItemImport.accountingPeriod) {
            return (
                title +
                " - Exercice du " +
                moment(accountingItemImport.accountingPeriod.start).format("DD/MM/YYYY") +
                " au " +
                moment(accountingItemImport.accountingPeriod.end).format("DD/MM/YYYY")
            );
        }
        if (accountingItemImport.startDate && accountingItemImport.endDate) {
            return (
                title +
                " - Période du " +
                moment(accountingItemImport.startDate).format("DD/MM/YYYY") +
                " au " +
                moment(accountingItemImport.endDate).format("DD/MM/YYYY")
            );
        }
        return "";
    }
}

export default toNative(CheckDoublonsWithAccountingItemImport);
</script>
